import { createApp } from 'vue';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueGtag from 'vue-gtag';

import Card from 'primevue/card';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Badge from 'primevue/badge';
import AutoComplete from 'primevue/autocomplete';
import Panel from 'primevue/panel';
import ProgressSpinner from 'primevue/progressspinner';
import Message from 'primevue/message';

import 'primeicons/primeicons.css';
import './styles/theme.scss'
import 'primevue/resources/primevue.min.css';
import './styles/style.scss'


const init = async () => {
    const module = await import('./router');
    const router = await module.default;
    const app = createApp(App).use(router);

    app.use(PrimeVue);
    app.use(VueReCaptcha, {siteKey: "6LejiOAfAAAAAIjg_4FcJLL2VC0XeBmwh3U8dJUq"});
    app.use(VueGtag, {
        config: { id: 'G-9GTF7NXCE6'},
    }, router)

    app.component('Card', Card);
    app.component('Button', Button);
    app.component('InputText', InputText);
    app.component('DataTable', DataTable);
    app.component('Column', Column);
    app.component('Badge', Badge);
    app.component('AutoComplete', AutoComplete);
    app.component('Panel', Panel);
    app.component('ProgressSpinner', ProgressSpinner);
    app.component('Message', Message);
    app.mount('#app');
}

init()
